module.exports = __webpack_public_path__ + "img/call-black.f01d8d38.svg";